import React from 'react';
import { motion } from 'framer-motion';
import { WindIcon, PauseIcon, MessagesSquareIcon, QuoteIcon, TargetIcon, MoonIcon, UsersIcon } from 'lucide-react';
const cards = [{
  icon: WindIcon,
  title: 'Bajar revoluciones',
  desc: 'Ejercicios breves para recuperar la calma durante una jornada exigente.'
}, {
  icon: PauseIcon,
  title: 'Responder sin reaccionar impulsivamente',
  desc: 'Aprendé a crear unos segundos de espacio antes de contestar en caliente.'
}, {
  icon: MessagesSquareIcon,
  title: 'Manejar conversaciones difíciles',
  desc: 'Herramientas para hablar de problemas, poner límites y afrontar situaciones incómodas.'
}, {
  icon: QuoteIcon,
  title: 'Saber qué decir',
  desc: '100 respuestas concretas para presión, críticas, interrupciones, manipulación y otras situaciones laborales.'
}, {
  icon: TargetIcon,
  title: 'Recuperar el foco',
  desc: 'Técnicas simples para cuando tenés demasiadas cosas en la cabeza.'
}, {
  icon: MoonIcon,
  title: 'Desconectar después del trabajo',
  desc: 'Pequeños rituales para dejar de seguir trabajando mentalmente cuando la jornada ya terminó.'
}, {
  icon: UsersIcon,
  title: 'Mejorar el ambiente laboral',
  desc: 'Ejercicios para construir acuerdos, comunicarse mejor y reducir fricciones innecesarias.'
}];
export function WhatYouLearn() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-277" data-mp="2m0vy3ywl2vcf">
      <div className="max-w-6xl mx-auto" data-id="element-278" data-mp="2lxhy2xbe6y85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-279" data-mp="2gzq4zzz0h62d">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-5" data-id="element-280" data-mp="a7xr0vjsocu5">
            <span className="text-xs font-bold tracking-widest" data-id="element-281" data-mp="1zrficobch431">
              🌿 QUÉ VAS A PODER HACER
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-282" data-mp="24j77qvirl3rl">
            Qué puede{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-283" data-mp="1uscakw3zcjrd">
              ayudarte a hacer
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-284" data-mp="2iiq46r27qqo2">
          {cards.map((c, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: i * 0.05
        }} className="bg-white border border-line rounded-3xl p-7 shadow-sm hover:shadow-lg transition-shadow" data-id="element-285" data-mp="2ng8f2mzsjfyp" data-mpi={i}>
              <div className="w-12 h-12 rounded-2xl bg-rose/10 flex items-center justify-center mb-5" data-id="element-286" data-mp="plkt7u9mzmzd">
                <c.icon className="w-6 h-6 text-rose" data-id="element-287" data-mp="14ivd9s0ci16p" />
              </div>
              <h3 className="font-serif font-bold text-lg text-ink mb-2 leading-snug" data-id="element-288" data-mp="zj901ikiokxw">
                {c.title}
              </h3>
              <p className="text-ink-soft text-sm leading-relaxed" data-id="element-289" data-mp="bsv7zs1xmm3b">{c.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}